import { fetchDataAPI } from '../helpers/fetchDataAPI';
import { URL_BASE_API } from './glogal';
import { store } from '../store'
import { Field } from 'formik';


export const passwordChange = (oldPassword, newPassword) => {
    const url = `${URL_BASE_API}/api/security/passwordchange`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const userId = store.getState().userLogged.userLogged.userId;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url,
        {
            field01: userId,
            field02: oldPassword,
            field03: newPassword,
            lang: language
        }, 
        config
    );
    
    return rsp;
}